import React, { useState, useEffect } from 'react';
import logo from '../../images/logo.webp';

const CookieConsentPopup = () => {
  const [visible, setVisible] = useState(false);
  const [optionsvisible, setOptionsVisible] = useState(false);

  useEffect(() => {
    const consent = getCookie('cookieConsent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setCookie('cookieConsent', 'accepted', 365);
    setVisible(false);
  };

  const handleReject = () => {
    setCookie('cookieConsent', 'rejected', 365);
    setVisible(false);
  };

  // Helper function to get cookie by name
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  };

  // Helper function to set cookie
  const setCookie = (name, value, days) => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/`;
  };

  return (
    visible && (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="flex flex-col w-full bg-white p-6 rounded-xl shadow-md hover:shadow-2xl transition-shadow duration-400 max-w-lg mx-auto relative">
          <div className="flex flex-row w-full mb-4">
            <div className="flex flex-wrap w-1/3 pl-2">
              <div className="font-poppins">
                <img
                  src={logo}
                  alt="Logo"
                  className="w-7 h-7 transform -translate-x-4"
                />
              </div>
              <div className="flex-container">
                <span className="text-xxs font-poppins transform -translate-x-4">
                  Digitale zahnpraxis{' '}
                </span>
                <span className="text-xxs text-primary dancing-script transform -translate-x-4">
                  Dr. Alshoutaiui
                </span>
              </div>
            </div>
            <div className="flex w-2/3 justify-start">
              <h2 className="text-md font-bold text-center">
                Cookies & Datenschutz
              </h2>
            </div>
          </div>
          <div className="flex flex-col items-start">
            <h2 className="font-bold text-sm mb-4 mt-2">
              Cookie-Zustimmung verwalten
            </h2>
            <p className="mb-4 text-xs">
              Um dir ein optimales Erlebnis zu bieten, verwenden wir
              Technologien wie Cookies, um Geräteinformationen zu speichern
              und/oder darauf zuzugreifen. Wenn du diesen Technologien
              zustimmst, können wir Daten wie das Surfverhalten oder eindeutige
              IDs auf dieser Website verarbeiten. Wenn du deine Zustimmung nicht
              erteilst oder zurückziehst, können bestimmte Merkmale und
              Funktionen beeinträchtigt werden.
            </p>
          </div>
          <button
            className="absolute top-0 right-0 p-5 text-3xl font-bold text-black hover:text-gray-700 focus:outline-none"
            onClick={() => setVisible(false)}
          >
            &times;
          </button>
          <div className="flex lg:flex-row flex-col w-full justify-center lg:space-x-4 mt-4">
            <button
              className="bg-primary text-white font-bold rounded-md text-md my-2 py-2 px-4 hover:shadow-xl transition-shadow duration-300"
              onClick={handleAccept}
            >
              Akzeptieren
            </button>
            <button
              className="bg-gray-100 rounded-md text-md my-2 py-2 px-4 hover:shadow-xl transition-shadow duration-300"
              onClick={handleReject}
            >
              Ablehnen
            </button>
            <button
              className="bg-gray-100 rounded-md text-md my-2 py-2 px-4 hover:shadow-xl transition-shadow duration-300"
              onClick={handleReject}
            >
              Einstellungen ansehen
            </button>
          </div>
          <div className="flex flex-wrap w-full justify-center">
            <a
              className="text-xs text-primary underline pt-4 px-2"
              href="https://zahnarztpraxishassan.web.app"
            >
              Cookie policy
            </a>
            <a
              className="text-xs text-primary underline pt-4 px-2"
              href="https://zahnarztpraxishassan.web.app"
            >
              Datenschutzerklärung
            </a>
          </div>
        </div>
      </div>
    )
  );
};

export default CookieConsentPopup;
